import $ from 'jquery'

$(document).ready(dhsv_vc_research_seminars_list_by_term())

function dhsv_vc_research_seminars_list_by_term() {
  $('.seminars-by-term-toggle-js').on('click', function() {
    $(this).toggleClass('active')
    $(this)
      .parents()
      .next('.seminars-lists-by-term-js')
      .slideToggle()
  })
}
